module.exports = __webpack_public_path__ + "img/map-first.b5b737cc.png";